/* eslint-disable react/prop-types */
import React from 'react';

const Choices = function Choices(props) {
  const formName = `choices${props.qid}`;
  // function to concat the qid with an answer, q01a1 q18a4 etc
  function aid(answer) { return `${props.qid}${answer}`; }

  const formEle = (
    <form id={formName} className="question__form" data-qid={props.qid}>
      <label className="question__choice bentoncond-n4" htmlFor={aid('a1')}>
        <input type="radio" name={formName} value={aid('a1')} onChange={props.handleChange} id={aid('a1')} />
        <span>{props.a1}</span>
      </label>
      <label className="question__choice bentoncond-n4" htmlFor={aid('a2')}>
        <input type="radio" name={formName} value={aid('a2')} onChange={props.handleChange} id={aid('a2')} />
        <span>{props.a2}</span>
      </label>
      {props.a3 && (
        <label className="question__choice bentoncond-n4" htmlFor={aid('a3')}>
          <input type="radio" name={formName} value={aid('a3')} onChange={props.handleChange} id={aid('a3')} />
          <span>{props.a3}</span>
        </label>
      )}
      {props.a4 && (
        <label className="question__choice bentoncond-n4" htmlFor={aid('a4')}>
          <input type="radio" name={formName} value={aid('a4')} onChange={props.handleChange} id={aid('a4')} />
          <span>{props.a4}</span>
        </label>
      )}
    </form>
  );
  return formEle;
};

export default Choices;
